import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const newsCarousels = document.querySelectorAll('.blog-carousel-block');

  if (0 < newsCarousels.length) {
    newsCarousels.forEach(function (newsCarousel) {
      new Swiper(newsCarousel.querySelector('.blog-carousel-block__carousel'), {
        slidesPerView: 1,
        slidesPerGroup: 1,
        draggable: true,
        spaceBetween: 30,
        watchSlidesProgress: true,
        a11y: {
          paginationBulletMessage: '',
          nextSlideMessage: 'Prochaine nouvelle',
          prevSlideMessage: 'Nouvelle précédente',
        },
        navigation: {
          nextEl: newsCarousel.querySelector(
            '.news-block__nav.swiper-button-next'
          ),
          prevEl: newsCarousel.querySelector(
            '.news-block__nav.swiper-button-prev'
          ),
        },
        pagination: {
          el: newsCarousel.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet(index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
          },
        },
        breakpoints: {
          769: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1100: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1400: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });
    });
  }
});
